import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container } from 'react-bootstrap';
import blogImage from './blogcover.png'; 
import blogImage2 from './blog2.png'; 
import blogImage3 from './blog3.jpg'; 

const BlogDetailPage1 = ({ onBack }) => {
    const navigate = useNavigate();

    const handleBlogClick = (blog) => {
        navigate(`/blogs/${blog.id}`);
    };
    const blogTitle = "Top 10 Business Ideas in Rural India That Need a Website in 2025";
    // const blogImage = "/src/pages/blog/blogcover.png";

    return (
        <Container >
            <Button onClick={onBack}
                className="mb-4"
                style={{
                    backgroundColor: '#fff',
                    color: '#333',
                    border: '1px solid #ddd',
                    fontWeight: '500'
                }}
            >
                ←
            </Button>
            <div
                style={{
                    //   background: 'linear-gradient(135deg, #FFB596, #ffd8c2)',
                    borderRadius: '10px',
                    padding: '2.5rem',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
                    fontFamily: 'Arial, sans-serif'
                }}
            >
                <h2 style={{ fontWeight: 700, fontSize: '2rem', color: '#333' }}>{blogTitle}</h2>

                <img
                    src={blogImage}
                    alt={blogTitle}
                    style={{
                        borderRadius: '20px',
                        width: '100%',
                        maxHeight: '450px',
                        objectFit: 'cover',
                        margin: '1.5rem 0'
                    }}
                />

                <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#222' }}>
                    In 2025, Digital India is not just a slogan. It's a ground-level reality. Villages are no longer cut off from the digital world. With cheaper smartphones and affordable internet, even the most remote areas are now connected. From watching YouTube to sending payments through UPI, rural India is going online. Sab kuch ab gaon tak pahuch gaya hai!
                </p>

                <p>
                    But one thing is still missing. Most rural businesses don’t have a website. And that’s a big opportunity. Whether you run a kirana store or a tailoring shop, a simple website can help you attract more customers, build trust, and grow your income.
                </p>

                <h4>Why a Website Matters for Rural Businesses</h4>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Most people Google everything before they buy (even groceries)</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> A website gives your business authenticity and trust (People trust Google)</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> You can receive orders, leads, or bookings online (so effortlessly)</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> It's your 24/7 shop, even when you're sleeping (make money while snoozing)</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> It helps you expand beyond your village or city (you can be an international brand)</li>
                </ul>
                <br />

                <h5>1. Kirana Store (General Store)</h5>
                <p>
                    Every village has a kirana shop. But what if people could check products online? Everyone needs groceries: rice, atta, dal, biscuits. Your kirana store serves the entire village. But with a website, you can take it a step further.
                </p>
                 <img
                    src={blogImage3}
                    alt={blogTitle}
                    style={{
                        borderRadius: '20px',
                        width: '55%',
                        maxHeight: '400px',
                        objectFit: 'contain',
                        margin: '1.5rem 0'
                    }}
                />
                <p><strong>Why a website helps:</strong></p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Show your daily essentials, snacks, groceries, etc.</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Post your store timing, discounts, and festive offers</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Allow locals to place orders online or via WhatsApp</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Accept UPI or online orders in advance</li>
                </ul>
                <p><strong>Example features for your site:</strong> Weekly deals page, Google Maps location, WhatsApp chat button</p>
                <p><em>Apna kirana ab digital hona chahiye!</em></p>
                <br />
                <h5>2. Organic Farming & Desi Produce</h5>
                <p>
                    Desi ghee, turmeric, honey, jaggery, other products from nature; people in cities are looking for these!
                </p>
                <p><strong>Why this rural business idea works:</strong></p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> You already have the resources (land, cows, traditional methods)</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> You can get premium prices if marketed properly</li>
                </ul>
                <p><strong>Why a website helps:</strong></p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Educate people about your farming methods</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Post clean, high-quality photos of your products</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Add payment options like UPI or QR code</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Partner with urban retailers or wellness brands</li>
                </ul>
                <p><em>Yeh hai asli rural business idea with profit.</em></p>
                <br />
                <h5>3. Handicrafts & Local Art</h5>
                <p>
                    From bamboo baskets to wooden toys and handwoven cloth, Indian villages are rich in art and craft. But many of them still rely on middlemen. That reduces their income.
                </p>
                <p><strong>Why this works online:</strong></p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Urban buyers love handmade, sustainable products</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Websites help showcase product photos, prices, and shipping options</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> You can even take bulk orders for weddings or exhibitions</li>
                </ul>
                <p><strong>Great for:</strong> Tribal communities, Women entrepreneurs, SHGs</p>
                <p><em>Apni kala ka asli daam tabhi milega jab aap khud online dikhaoge.</em></p>
                <br />
                <h5>4. Tailoring & Boutique</h5>
                <p>
                    Ladies in small towns are rocking the tailoring business. Why not take it online?
                </p>
                                 <img
                    src={blogImage2}
                    alt={blogTitle}
                    style={{
                        borderRadius: '20px',
                        width: '55%',
                        maxHeight: '400px',
                        objectFit: 'contain',
                        margin: '1.5rem 0'
                    }}
                />
                <p><strong>Why a website helps:</strong></p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span>Share the portfolio of stitched dresses</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Offer home delivery and online booking</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Build trust with customer reviews</li>
                </ul>
                <p><em>Bas website hona chahiye. Orders khud milne lagenge.</em></p>
                <br />
                <h5>5. Poultry or Dairy Business</h5>
                <p><strong>Milk, eggs, paneer:</strong> demand is always there.</p>
                <p><strong>Why a website helps:</strong></p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Share rates and availability</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Connect with hotels, shops, and delivery apps</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Receive bulk orders</li>
                </ul>
                <p><em>Desi doodh ki website ho toh log line laga denge!</em></p>
                <br />
                <h5>6. Coaching Classes or Tuition Center</h5>
                <p>Tuition is a big need in rural areas. But competition is growing too.</p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Show your teaching style and timings</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Post success stories and testimonials</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Let parents contact you directly</li>
                </ul>
                <br />
                <h5>7. Beauty Parlour or Grooming Services</h5>
                <p>Parlours are booming in villages. Add a digital touch to your Dukan.</p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Show services and prices</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Let users book appointments</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Add a WhatsApp button for easy contact</li>
                </ul>
                <br />
                <h5>8. Mobile Repair & Recharge Shop</h5>
                <p>Most people now use smartphones, even in small villages.</p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> List services like screen repair, battery change</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Offer doorstep repair or home pick-up</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Take online appointments</li>
                </ul>
                <p><em>Website banao. Tech wale bhi digital ho jao.</em></p>
                <br />
                <h5>9. Homestay or Village Tourism</h5>
                <p>Rural tourism is rising. Foreigners and Indians love staying in real villages.</p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Share photos of homestay and village life</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Take bookings</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Tell your unique story</li>
                </ul>
                <p><em>Website lagao, guests aapke paas khud chal kar aayenge.</em></p>
                <br />
                <h5>10. Self-Help Group (SHG) Products</h5>
                <p>From papads to pickles, SHGs are making magic.</p>
                <ul>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Sell directly to consumers</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Get bulk orders from city shops</li>
                    <li> <span style={{fontSize: 20, marginRight: 10 }}> • </span> Accept payments via UPI or QR code</li>
                </ul>
                <p><strong>Great content to add:</strong> Your team story, Ingredients used, Photos of packaging</p>
                <p><em>Website bana ke apna “Swadeshi Amazon” start karo!</em></p>

                <h4 style={{ marginTop: '2rem' }}>Final Words</h4>
                <p>
                    Having a village business website is not a luxury anymore. It is a basic digital identity. People search online. If your business is not on Google, you are invisible.
                </p>
                <p>
                    With platforms like the MyDigitalIndia App, you don’t need coding skills. Just upload your details. Your website is ready in minutes.
                </p>
                <p>
                    Rural India has talent, ideas, and hard work. All it needs is digital exposure. Start with a website for your small business. It’s simple, affordable, and gives real results.
                </p>
                <p><strong>Ab gaon ke business bhi global ho sakte hain!</strong></p>
            </div>
        </Container>
    );
};

export default BlogDetailPage1;
